module.exports = __webpack_public_path__ + "img/a6eb0ab.jpg";